import { render, staticRenderFns } from "./MigrationNotificationProvider.vue?vue&type=template&id=59cec947&"
import script from "./MigrationNotificationProvider.vue?vue&type=script&lang=js&"
export * from "./MigrationNotificationProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports